import Flex from '@/components/common/Flex';
import { Dropdown } from 'react-bootstrap';
import { useAppContext } from '@/Main';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NavbarDropdown from './NavbarDropdown';
import { flatRoutes, routeToHandler } from '@/helpers/utils';
import {
  settingRoutes,
  toolRoutes,
  financeRoutes,
  dashboardRoutes,
  supportRoutes
  // aiAssistantRoutes
} from '@/routes/siteMaps';
import { useSelector } from 'react-redux';
import DomainSelector from '@/app/common/components/DomainSelector';
import NavbarDropdownTools from './NavbarDropdownTools';
import SubtleBadge from '@/components/common/SubtleBadge';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { openAiSupportChat } from '@/components/navbar/openAiSupportChat';

type RouteTab = {
  name: string;
  label?: string;
  to?: string;
  disabled?: boolean;
  icon?: IconProp;
  target?: string;
  action?: string;
  badge?: { type: string; text: string };
  children?: RouteTab[];
};

type NavbarRootState = {
  selectedDomain: { name: string; slug?: string };
};

const mainRoutesConverterToTab = (routesObj: {
  label: string;
  children?: RouteTab[];
}) => {
  return { ...routesObj, name: routesObj.label };
};

const NavbarTopDropDownMenus = () => {
  const {
    config: { navbarCollapsed, showBurgerMenu, navbarPosition },
    setConfig
  } = useAppContext();

  const handleDropdownItemClick = () => {
    if (navbarCollapsed) {
      setConfig('navbarCollapsed', !navbarCollapsed);
    }
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };

  const { pathname } = useLocation();
  const { slug, domain, domain_slug, loc, lang, keyword } = useParams();
  const selectedDomain = useSelector(
    (state: NavbarRootState) => state.selectedDomain
  );

  return (
    <div>
      <Flex alignItems="center" className="gap-3">
        {navbarPosition !== 'combo' && (
          <div style={{ width: 180 }}>
            <DomainSelector />
          </div>
        )}
        {[
          ...dashboardRoutes.children,
          // mainRoutesConverterToTab(aiAssistantRoutes),
          mainRoutesConverterToTab(toolRoutes),
          mainRoutesConverterToTab(supportRoutes),
          mainRoutesConverterToTab(financeRoutes),
          mainRoutesConverterToTab(settingRoutes)
        ].map((m, i) => {
          return m.name === 'ابزارها' ? (
            <NavbarDropdown key={i} title={m.name}>
              <NavbarDropdownTools tools={m.children ?? []} />
            </NavbarDropdown>
          ) : m.children ? (
            <NavbarDropdown key={i} title={m.name}>
              {flatRoutes(m.children).map(route => (
                <Dropdown.Item
                  key={route.name}
                  as={NavLink}
                  target={route.target || undefined}
                  to={routeToHandler(
                    route,
                    selectedDomain,
                    domain,
                    domain_slug,
                    slug,
                    loc,
                    lang,
                    keyword
                  )}
                  state={{ path: `${pathname}`, query: null }}
                  disabled={route.disabled}
                  onClick={event => {
                    if (route.action === 'openAiSupportChat') {
                      event.preventDefault();
                      openAiSupportChat();
                    }
                    if (route.name === 'Modal') {
                      setConfig('openAuthModal', true);
                    }
                    handleDropdownItemClick();
                  }}
                  className={({ isActive }: { isActive: boolean }) =>
                    route.disabled
                      ? 'nav-link disabled-link'
                      : isActive && route.to !== '#!'
                        ? 'active nav-link'
                        : 'nav-link'
                  }
                >
                  {route.icon && (
                    <FontAwesomeIcon icon={m.icon!} className="me-2" />
                  )}
                  {route.name}
                  {route.badge && (
                    <SubtleBadge pill bg={route.badge.type} className="ms-2">
                      {route.badge.text}
                    </SubtleBadge>
                  )}
                </Dropdown.Item>
              ))}
            </NavbarDropdown>
          ) : (
            <NavLink
              key={i}
              className={({ isActive }) =>
                m.disabled
                  ? 'nav-link navLinkForceColor py-1 disabled-link'
                  : isActive && m.to !== '#!'
                    ? 'active navLinkForceColor nav-link py-1'
                    : 'nav-link navLinkForceColor py-1'
              }
              to={routeToHandler(
                m,
                selectedDomain,
                domain,
                domain_slug,
                slug,
                loc,
                lang,
                keyword
              )}
            >
              {m.icon && <FontAwesomeIcon icon={m.icon} className="me-2" />}
              {m.name}
              {m.badge && (
                <SubtleBadge pill bg={m.badge.type} className="ms-2">
                  {m.badge.text}
                </SubtleBadge>
              )}
            </NavLink>
          );
        })}
      </Flex>
    </div>
  );
};

export default NavbarTopDropDownMenus;
